import { IRibbonState } from "./interfaces";

export const DEFAULT_RIBBON_STATE: IRibbonState = {
	debug: false,
	userVariant: "A",
	activeContents: [],
	enabled: false,
	enabledLocation: "ribbon",
	hidden: false,
	minimalized: true,
};
